import { jsx } from "react/jsx-runtime";
import { Shuffle } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useCallback } from "react";
import tinycolor from "tinycolor2";
import { useColorPicker } from "../../../hooks/useColorPicker.js";
import { Tooltip } from "../../Tooltip.js";
function RandomColorButton() {
  const { onChange, localeText } = useColorPicker();
  const onClick = useCallback(() => {
    const randomHexColor = tinycolor.random().toHexString();
    onChange(null, randomHexColor);
  }, [onChange]);
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      placement: "bottom",
      title: localeText.randomColorActionTooltip,
      "data-testid": "TidalColorPickerRandomColorButton",
      children: /* @__PURE__ */ jsx(IconButton, { onClick, children: /* @__PURE__ */ jsx(Shuffle, {}) })
    }
  );
}
export {
  RandomColorButton
};
//# sourceMappingURL=RandomColorButton.js.map
